export default "__VITE_ASSET__BPOCFI2c__"